<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">{{routeName}}</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/playlists/list" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="update" v-if="playlist">
                <div class="row justify-content-md-center">
                    <div class="col-12">
                        <div class="row">
                          <div class="col-12" v-if="corps.length">
                            <multiselect
                              v-model="playlist.csvCorporationId"
                              placeholder="Select Corporation"
                              :multiple="true"
                              :taggable="true"
                              :options="corps.map(type => type.corporationId)"
                              :custom-label="opt => corps.find(x => x.corporationId == opt).name">
                              >
                            </multiselect>
<!--                            <fg-select-->
<!--                              v-model="playlist.corporationId"-->
<!--                              label="Select Corporation"-->
<!--                              :list="corps"-->
<!--                              selectedKey="corporationId"-->
<!--                              v-validate="rules.corporationId"-->
<!--                              data-vv-name="Corproration"-->
<!--                              cus-name="Corporation"-->
<!--                              :has-errors="errors"-->
<!--                              :is-fields="fields"-->
<!--                            >-->
<!--                            </fg-select>-->
                          </div>
                            <div class="col-md-12">
                                <fg-input type="text"
                                          v-model="playlist.playlistTitle"
                                          label="Title"
                                          placeholder="Enter Title"
                                          v-validate="rules.playlistTitle"
                                          data-vv-name="Title"
                                          cus-name="Title"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>
                            </div>
                          <div class="col-md-12">
                            <fg-input type="text"
                                      v-model="playlist.playlistDescription"
                                      label="Description"
                                      placeholder="Enter Description"
                                      v-validate="rules.playlistDescription"
                                      data-vv-name="Description"
                                      cus-name="Description"
                                      :has-errors="errors"
                                      :is-fields="fields">
                            </fg-input>
                          </div>
                          <div class="col-md-12">
                            <fg-input type="text"
                                      v-model="playlist.csvVideoCodes"
                                      label="Video Codes"
                                      placeholder="Enter Video Codes (comma separated)"
                                      v-validate="rules.csvVideoCodes"
                                      data-vv-name="Video Codes"
                                      cus-name="Video Codes"
                                      :has-errors="errors"
                                      :is-fields="fields">
                            </fg-input>
                          </div>
                            <div class="col-md-3" v-if="status.length">
                                <fg-select
                                        v-model="playlist.active"
                                        label="playlist"
                                        v-validate="rules.active"
                                        data-vv-name="active"
                                        cus-name="active"
                                        :has-errors="errors"
                                        :is-fields="fields"
                                        :list="status"
                                        selectedKey="id"
                                        >
                                </fg-select>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any() || (!playlist.csvCorporationId || playlist.csvCorporationId.length === 0)" class="btn btn-primary btn-fill btn-block">
                            Update Playlist
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    export default {
        name: 'EditPlaylist',
        created (){
          let self = this
        this.$store.dispatch('GETSELECTEDPLAYLIST', this.$route.params.id)
        this.fetchCorporations();
        setTimeout(() => {
          // self.corpIds = self.playlist.csvCorporationId.split(',')
          self.playlist.csvCorporationId = self.playlist.csvCorporationId.split(',')
          console.log('returned csv', self.playlist.csvCorporationId)
          console.log('coprIds', self.corpIds)
        }, 1500)
    },
    data () {
        return {
            corpIds: null,
            largeNewImage: [],
            smallNewImage: [],
            playlistString: '',
            corps: [],
//            playlist: null,
            status: [{name:'Select Status'}, {id:1, name:'Active'}, {id:0, name:'Inactive'}],
            rules: {
              csvCorporationId : {required: true},
              playlistTitle: {required: true},
              playlistDescription: {required: true},
              csvVideoCodes: {required: true}
            }
        }
    },
    methods: {
      fetchCorporations () {
        this.$store.dispatch('FETCH_CORPORATIONS')
          .then((res) => {
            this.corps = res;
            console.log("this.corporations : ", this.corps);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
        update () {
            this.$validator.validateAll().then((result) => {
                if(result){
                    let update = () =>{
                        this.$store.dispatch('UPDATE_PLAYLIST_CORPORATION_NEW', this.playlist)
                                .then((res) => {
                                    console.log("UPDATE_CORPORATION res : ", res);
                                    this.showPopup('Success!', 'Corporation Playlist is successfully updated', 'success', ()=>this.$router.push('/admin/playlists'))
                                })
                                .catch(err => {
                                    this.showPopup('Error!', 'some thing happen wrong', 'error')
                                    console.log("UPDATE_CORPORATION API error : ", err);
                                })
                    };
                    update();
                }
            })
            console.log("this.corporations : ", this.corporations);
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        },
        capitalizeFirstLetter (string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        },
        updateLargeImg(data){
            this.corporation.largeImage = data.path;
            this.largeNewImage = data.value;
            console.log("updateLargeImg data : ", data);
        },
        updateSmallImg(data){
            this.corporation.smallImage = data.path;
            this.smallNewImage = data.value;
            console.log("updateSmallImg data : ", data);
        },
    },
    computed: {
        ...mapGetters([ 'corporations', 'selectedPlaylist']),
        routeName () {
            const {name} = this.$route;
            return this.capitalizeFirstLetter(name);
        },
        playlist(){
            return this.selectedPlaylist
        }
    }
    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Playlists/EditPlaylist.vue